<template>
  <div class="wrap">
    <div class="ct-waterfall">
      <ul id="pic-ct" class="cf">
       <li class="item">
          <a href="#" class="link">
            <img src="http://s.img.mix.sina.com.cn/auto/resize?img=http%3A%2F%2Fwww.sinaimg.cn%2Fdy%2Fslidenews%2F5_img%2F2016_09%2F453_75615_657883.jpg&size=250_0" alt="">
          </a>
          <h4 class="header">标题</h4>
          <p class="desp">
            当地时间2016年3月1日，在东部与亲俄武装作战中受伤的乌克兰士兵接受海豚治疗。
          </p>
        </li>

        <!-- 用于计算 item 宽度和列数，但不展示出来-->
        <li class="item hide"></li>
      </ul>
      <div id="load">我是看不见的</div>
    </div>
  </div>
</template>

<script>
// --------------- LIB --------------- //
// 获取数据API
function getData(currentPage, num){
  return new Promise((resolve, reject)=>{
    $.ajax({
      url: 'http://platform.sina.com.cn/slide/album_tech',
      dataType: 'jsonp',   
      jsonp:"jsoncallback",
      data: {
        app_key: '1271687855',
        num:  num || 10,
        page: currentPage
      },
      success: (res)=>{
        resolve(res.data)
      },
      error: (error)=>{
        reject(error)
      }
    })
  })
}

// 瀑布流
function WaterFall ($container, margin){
  let _this = this
  this.margin = margin || 0
  this.waterFallList = $container.children()
  this.elWidth = this.waterFallList.eq(0).width()
  this.colsNum = Math.floor($container.width()/this.elWidth)
  this.cols = new Array(this.colsNum).fill(0) || []

  //   内置新增项
  this._setItemPosition = function ($el){
    let colIndex = minIndex()
    $el.css({top: this.cols[colIndex] || 0, left: (this.elWidth+this.margin)*colIndex})
    $el.animate({opacity: 1}, 300)
    // 更新列表高度
    this.cols[colIndex] += $el.outerHeight()+this.margin
    console.log($el.outerHeight()+this.margin)
  }

  //   外部新增项
  this.appendItem = (itemStr)=>{
    let $el = $container.append(itemStr).children().last()
  //   防止item计算出现较大误差
    $el.find('img').on('load',()=>{
      this._setItemPosition($el)
    })
  }

  //   返回数组最小值的索引
  function minIndex() {
    let index = 0
    for(let i = 1;i<_this.cols.length;i++) {
      if(_this.cols[index]>_this.cols[i]) {
        index = i
      }
    }
    return index
  }
  return this
}

// 创建新元素字符串
function renderItem(itemData){
  return `<li class="item">
  <a href="${itemData.url}" target="_blank" class="link">
  <img src="${itemData.img_url}" alt="">
  </a>
  <h4 class="header">${itemData.short_name || itemData.name}</h4>
  <p class="desp">${itemData.short_intro}</p>
  </li>
  `
}

export default {
  mounted(){
    let wf = new WaterFall($('#pic-ct'), 10)
    wf.cp = 1
    wf.flash = 0
    wf.getCurrentPage = ()=>{
      wf.flash = 1;
      getData(wf.cp).then((data)=>{
        wf.cp+=1
        data.forEach((item)=>{
          wf.appendItem(renderItem(item))
        })
      }).then(()=>{
        wf.flash = 0;
      })
    }
    wf.getCurrentPage()
    window.wf = wf

    $(document).on('scroll', (ev)=>{
      let diff = Math.abs($(window).scrollTop() + $(window).height() - $(document).height())
      if(!wf.flash && diff<15) {
        wf.getCurrentPage()
      }
    })
  }
}
</script>

<style lang="sass">
.ct-waterfall
  width: 900px;
  margin: auto;
  #pic-ct
    position: relative;
    .item
      position: absolute;
      padding: 0 0 10px 0;
      width: 280px;
      margin: 10px;
      border: 1px solid #DFDFDF;
      background: #FFF;
      opacity: 0;
      transition: all .8s;
      img
        margin: 10px;
        width: 260px;
      .header
        height: 25px;
        margin: 0 12px;
        border-bottom: 1px solid #DBDBDB;
    .desp
      font-size: 12px;
      line-height: 1.8;
      margin: 10px 15px 0;
      color: #777371;
  #load
    visibility: hidden;
    height: 20px;
  .hide
    display: none;
</style>


// WEBPACK FOOTER //
// src/components/Waterfall.vue